export default "__VITE_ASSET__e60cf1db__"